import React from 'react';
import { Sparkles, Wrench, Shirt, Home, ClipboardCheck, Trees, Paintbrush, Lock, Bug, Truck, Shield, Trash2 } from 'lucide-react';

const ICON_MAP = {
  sparkles: Sparkles,
  wrench: Wrench,
  shirt: Shirt,
  home: Home,
  'clipboard-check': ClipboardCheck,
  trees: Trees,
  paintbrush: Paintbrush,
  lock: Lock,
  bug: Bug,
  truck: Truck,
  shield: Shield,
  'trash-2': Trash2,
};

const COLORS = [
  'bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100',
  'bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-100',
  'bg-purple-50 text-purple-600 border-purple-200 hover:bg-purple-100',
  'bg-green-50 text-green-600 border-green-200 hover:bg-green-100',
  'bg-rose-50 text-rose-600 border-rose-200 hover:bg-rose-100',
  'bg-teal-50 text-teal-600 border-teal-200 hover:bg-teal-100',
  'bg-orange-50 text-orange-600 border-orange-200 hover:bg-orange-100',
  'bg-indigo-50 text-indigo-600 border-indigo-200 hover:bg-indigo-100',
  'bg-red-50 text-red-600 border-red-200 hover:bg-red-100',
  'bg-cyan-50 text-cyan-600 border-cyan-200 hover:bg-cyan-100',
  'bg-yellow-50 text-yellow-600 border-yellow-200 hover:bg-yellow-100',
  'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100',
];

const CategoryGrid = ({ categories, selectedCategory, onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
      {categories.map((cat, idx) => {
        const IconComponent = ICON_MAP[cat.icon] || Wrench;
        const isSelected = selectedCategory === cat.id;
        const colorClass = COLORS[idx % COLORS.length];

        return (
          <button
            key={cat.id}
            onClick={() => onSelect(isSelected ? null : cat.id)}
            className={`flex flex-col items-center gap-2 p-4 rounded-xl border-2 transition-all cursor-pointer ${
              isSelected
                ? 'border-[#1F3A68] bg-[#1F3A68] text-white shadow-lg scale-105'
                : colorClass
            }`}
          >
            <IconComponent size={28} />
            <span className="text-xs font-semibold text-center leading-tight">{cat.label}</span>
            <span className="text-[10px] opacity-70">{cat.subcategories?.length || 0} services</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryGrid;
